// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import LocationSvg from '@rsuite/icon-font/lib/people/Location';
var Location = createSvgIcon({
  as: LocationSvg,
  ariaLabel: 'location',
  category: 'people',
  displayName: 'Location'
});
export default Location;